const StaticMap = () => {
    return (
        <div id="static_maps">
            <div className="dynamic_headline">
                The share of adults in the lower-income tier was highest in
                Laredo, TX and Brownsville-Harlingen, TX (47%) and lowest in
                Wausau, WI, Sheboygan, WI and Barnstable Town, MA (18%).
            </div>
            <img src="//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/ST_16.03.18_MiddleIncome_MetroAreaStaticMaps_LOWER.png" />
            <div className="dynamic_headline">
                The share of adults in the middle-income tier was highest in
                Wausau, WI (67%) and lowest in Monroe, LA (42%).
            </div>
            <img src="//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/ST_16.03.18_MiddleIncome_MetroAreaStaticMaps_MIDDLE.png" />
            <div className="dynamic_headline">
                The share of adults in the upper-income tier was highest in
                Midland, TX (37%) and lowest in Laredo, TX,
                McAllen-Edinburg-Mission, TX, Las Cruces, NM and
                Visalia-Porterville, CA (9%).
            </div>
            <img src="//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/ST_16.03.18_MiddleIncome_MetroAreaStaticMaps_UPPER.png" />
        </div>
    );
};

export default StaticMap;
